export default __webpack_public_path__ + "static/media/YETI.e6edb584.png";